<template>
  <div class="container brilliant">
    <indexTitle english_title="Brilliant Activity" chinese_title="展覽花絮"></indexTitle>
    <div class="swiper_box">
   <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" id="select" v-for="item in slider_img" :key="item.id"  @click="open(item.id);index = 0">
            <div class="slide_img">
              <img :src='item.image_url' alt="">
            </div>
            <div class="d-flex brilliant_text ">
              <div>
                {{item.title}}
              </div>
            </div>         
          </div>
          <div v-show="slider_img.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
        </div>
        </div>
      </div>
      <div class="swiper-button-next2"></div>
      <div class="swiper-button-prev2"></div>
    </div>
    <vue-gallery-slideshow ref="childMethod" :images="images" :index="index" @close="index = null" @touchstart.native="starttouch()"  @touchmove.native="mytouch()" @touchend.native="endtouch()"></vue-gallery-slideshow>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
import Swiper from 'swiper'; 
import 'swiper/dist/css/swiper.min.css';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import { setTimeout } from 'timers';

export default {
  name: 'brilliant',
  props: {},
  components: {
    'indexTitle': IndexTitle,
     VueGallerySlideshow,
  },
  data () {
    return {
      slidesPerView:3,
      slider_img: [
             
      ],
      slider_thumb:[],
      images:[],
       index: null,
       Beforemoving:0,
       Aftermoving:0,
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
  mounted(){
    var vm = this; 
    var slider_api = vm.API + 'api/tlweb/history'
    this.axios.get(slider_api)
      .then(function (response) {
      vm.slider_img = response.data.data.data.filter(function(item){
        
        var extIndex = item.image_url.lastIndexOf('.');
        var patt = '_thumb';
        item.image_url = item.image_url.substr(0, extIndex) + patt + item.image_url.substr(extIndex, extIndex + patt.length);
        // console.log("filter")
        return item.image.image_url!="" && item.exhibit_history_photo!="";   
      });
      // console.log("ok1")
        setTimeout(() => {
         vm.swiper()
      } , 100)
      
      })
      .catch(function (error) {
        console.log(error);
      });
      // console.log("ok2")
  },
   updated(){
      
      var thumb_reset = document.getElementsByClassName('vgs__gallery__container')[0];
      // console.log(thumb_reset)
      if(thumb_reset){
        if(thumb_reset.style.transform != 'translate(0px, 0px)'){
          thumb_reset.style.transform='translate(0px, 0px)'
        }
      }
      
      var scroll = document.getElementsByClassName('brilliant')[0].lastChild.innerHTML;
      if(scroll!=undefined){
        document.body.style.overflow='hidden';
      }else{
        document.body.style.overflow='auto';
      }

   },
   methods: {
     swiper(){
         new Swiper('.brilliant .swiper-container', {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
      clickable: true,
      },
      breakpoints: {
        1000: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      observer:true,//修改swiper自己或子元素时，自动初始化swiper
      // observeParents:true,//修改swiper的父元素时，自动初始化swiper

       navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
      },
    });
     },
    open(id) {
      this.images=[];
      // var count;
      // var l1 =this.slider_img.length;      
      // for(count = 0 ; count < l1 ; count ++){
      //   if(this.slider_img[count].id==id){
      //      var img = this.slider_img[count];
      //      var l2 = img.exhibit_history_photo.length;
      //      var thumb_img;
      //     for(thumb_img = 0; thumb_img<l2;thumb_img++){
      //       this.images.push(img.exhibit_history_photo[thumb_img].history_image_url)
      //     }
      //   }
      // }
      var low = 0, high = this.slider_img.length-1
      while (low <= high){

        var mid = parseInt((low + high)/2)
        // console.log("id="+id)
        // console.log("low="+low)
        // console.log("high="+high)
        // console.log("mid="+mid)
        // console.log(parseInt(this.slider_img[mid].id)+","+id)
        // console.log(15> 5)
        // console.log("----------")
        if (parseInt(this.slider_img[mid].id)  > id)
        {
            high = mid - 1
        }else if (parseInt(this.slider_img[mid].id) < id){
            low = mid + 1
        }else{
            var img = this.slider_img[mid];
            var l2 = img.exhibit_history_photo.length;
            var thumb_img;
            for(thumb_img = 0; thumb_img<l2;thumb_img++){
                this.images.push(img.exhibit_history_photo[thumb_img].history_image_url)
              }
            break;
            }
        }

           
    },
    starttouch(){
      var x = event.touches[0].clientX;
      this.Beforemoving=x;
      // console.log("Beforemoving="+this.Beforemoving)
    },
   mytouch() {
      var x = event.touches[0].clientX;
      this.Aftermoving=x;
      // console.log("Aftermoving="+this.Aftermoving)
    },
    endtouch(){
      // console.log("Beforemoving2="+this.Beforemoving)
      // console.log("Aftermoving2="+this.Aftermoving)
      // console.log(this.Beforemoving-this.Aftermoving)
      // console.log(this.Beforemoving!=this.Beforemoving-this.Aftermoving>50)
      if( this.Aftermoving!=0){
        if(this.Beforemoving-this.Aftermoving>50){
          this.$refs.childMethod.onNext()
        }
      if(this.Beforemoving-this.Aftermoving<-50){
          this.$refs.childMethod.onPrev()
        }
      }
      this.Aftermoving=0;
    }
  }
}
</script>

<style lang="sass">
.brilliant
  .swiper_box
    width: 100%
    position: relative
    margin-bottom: 15px
  .swiper-container
    width: 90%
  .swiper-slide
    width: 100%
    cursor: pointer
    .slide_img
      width: 100%
      height: 197px
    img
      width: 100%
      height: 100%
      object-fit: cover
  .brilliant_text
    flex-direction: column
    justify-content: center
    align-items: center
    margin: 10px auto
    width: 90%
    color: black
    line-height: 26px
  .swiper-slide:hover .brilliant_text
    color: #00a0e9
  .swiper-button-next2
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E")
    right: 10px
    left: auto;
  .swiper-button-prev2
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E")
    left: 10px;
    right: auto;
  .swiper-button-next2, .swiper-button-prev2 
    position: absolute;
    top: 40%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: center;
    background-repeat: no-repeat;
  .swiper-button-next2.swiper-button-disabled,.swiper-button-prev2.swiper-button-disabled
    opacity: .35;
    cursor: auto;
    pointer-events: none;
  


.vgs__container
  width: 100%
  img
    //width: auto
    margin: 0 auto
    display: block
  .vgs__container__img
    max-height: 100%;
    width: auto;
    height: auto;

@media (max-width: 768px)
  .brilliant
    .swiper-slide .slide_img
      max-width: 400px
      max-height: 225px
      margin: 10px auto
    .brilliant_text
      margin: 0 auto
    .swiper-container
      width: 80%
    .vgs__container__img
      // width: 100%    
      //max-width: 100%
    .swiper-button-next2, .swiper-button-prev2 
      top: 45%  
  .vgs__prev, .vgs__next
    display: none
  
@media (max-width: 375px)
  .vgs__container__img 
    //height: auto !important

.brilliant
  .swiper-button-next, .swiper-button-prev
    top: 40%

.vgs__container
  background-color: transparent !important

.vgs__gallery
  width: 100%

.vgs__gallery__container__img--active
  border: 2px solid white

.vgs__container img
  border: 10px solid white
  max-width: 100%;

@media (min-width: 0)
  .vgs__gallery
    display: block !important

@media (min-width: 767px)
  .vgs__container
    top: 50% !important
    left: 0 !important
    right: 0 !important
    transform: translateY(-60%)

  .vgs__prev, .vgs__next
    font-size: 90px !important
    margin-top: -50px !important
    width: 70px !important
    height: 100px !important
    
</style>
